<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Datos afiliado</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div class="p-2">
            <mat-label class="lblblack">{{this.form.get('nroDocumento').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack2">{{this.form.get('nombresApellidos').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Fecha afiliación</mat-label>
            <mat-label class="lblblack2 lblmargen">{{this.form.get('fechaAfiliacion').value | fechapipe}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Producto</mat-label>
            <mat-label class="lblblack2 lblmargen">{{this.form.get('producto').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="MostrarEdad()">
            <mat-label class="lblblack" *ngIf="MostrarEdad()">Edad</mat-label>
            <mat-label class="lblblack2 lblmargen" *ngIf="MostrarEdad()">{{this.form.get('edad').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Estado</mat-label>
            <mat-label class="lblblack lblmargen" [class]="this.form.get('estadoColor').value">{{this.form.get('estado').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">
            <mat-label class="lblblack" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">Tipo</mat-label>
            <mat-label class="lblblack lblmargen" [class]="this.form.get('estadoDescripcionColor').value" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">{{this.form.get('estadoDescripcion').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="MostrarTerminosCondiciones()">
            <mat-label class="lblblack" *ngIf="MostrarTerminosCondiciones()">Términos y condiciones</mat-label>
        </div>
        <div class="p-0 marginiconoterminos" *ngIf="MostrarTerminosCondiciones()">
            <a type="button" class="icnTable" target="_blank" [href]="this.form.get('rutaTerminosCondiciones').value" *ngIf="MostrarTerminosCondiciones()">
                <mat-icon>find_in_page</mat-icon>
            </a>
        </div>
        <div class="p-2" *ngIf="MostrarControlOperaciones()">
            <mat-label class="lblblack" *ngIf="MostrarControlOperaciones()">Control operaciones</mat-label>
        </div>
        <div class="p-0 marginiconoterminos" *ngIf="MostrarControlOperaciones()">
            <a type="button" class="icnTable" target="_blank" [href]="this.form.get('rutaControlOperaciones').value" *ngIf="MostrarControlOperaciones()">
                <mat-icon>info</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap mt-2" *ngIf="this.consultoDatos">
        <div *ngFor="let item of this.gestionAfiliado_DatosAdicionales.listaDatosAdicionales">
            <div class="detalleadicionaltitulo">{{item.campo}}</div>
            <div class="detalleadicional">{{item.valor}}</div>
        </div>
    </div>
    <mat-tab-group class="mt-2 tabbeneficiarios" mat-align-tabs="start" *ngIf="this.consultoDatos && this.form.get('mostrarBeneficiarios').value">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Beneficiarios</span>
            </ng-template>
            <div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceBeneficiarios" matSort class="table table-striped table-hover">

                            <ng-container [matColumnDef]="item" *ngFor="let item of columnasEncabezadoBeneficiarios">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{item}}</th>
                                <td mat-cell *matCellDef="let row">
                                    {{row[item]}}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoBeneficiarios"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoBeneficiarios;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-12" style="text-align: right;">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex justify-content-between flex-wrap filtrosTablesecundario align-items-center" autocomplete="off" *ngIf="this.TieneDocumentosAjuntos()">
        <div class="p-2">
            <mat-label class="lblblack">Registro fotografico</mat-label>
        </div>
        <div>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
    <div class="pl-0 pr-0 mat-elevation-z8 mt-2" *ngIf="this.TieneDocumentosAjuntos()">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSourceDatosDocumentos" matSort class="table table-striped table-hover">

                <!-- id Column -->
                <ng-container matColumnDef="nro">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> N°</th>
                    <td mat-cell *matCellDef="let row"> {{row.contador}} </td>
                </ng-container>

                <!-- fotografia Column -->
                <ng-container matColumnDef="fotografia">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fotografia </th>
                    <td mat-cell *matCellDef="let row"> {{row.nombre }} </td>
                </ng-container>

                <!-- acciones Column -->
                <ng-container matColumnDef="archivo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fotografia </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" (click)="DescargarDocumento(row)" class="icnTable">
                            <mat-icon>cloud_download</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezadoDocumentos"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezadoDocumentos;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTablesecundario align-items-center" autocomplete="off">
        <div class="p-2">
            <mat-label class="lblblack">Gestión al afiliado</mat-label>
        </div>
        <div>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
    <div class="pl-0 pr-0 mat-elevation-z8 mt-2">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSourceDatosMovimientos" matSort class="table table-striped table-hover">

                <!-- id Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> N°</th>
                    <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                </ng-container>

                <!-- fecha Column -->
                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
                    <td mat-cell *matCellDef="let row"> {{row.fecha | fechapipe}} </td>
                </ng-container>

                <!-- operacion Column -->
                <ng-container matColumnDef="operacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Operación </th>
                    <td mat-cell *matCellDef="let row"> {{row.operacion}} </td>
                </ng-container>

                <!-- expediente Column -->
                <ng-container matColumnDef="expediente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Expediente </th>
                    <td mat-cell *matCellDef="let row"> {{row.expediente}} </td>
                </ng-container>

                <!-- registro Column -->
                <ng-container matColumnDef="registro">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Registro </th>
                    <td mat-cell *matCellDef="let row"> {{row.registro}} </td>
                </ng-container>

                <!-- gestiono Column -->
                <ng-container matColumnDef="gestiono">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Gestiono </th>
                    <td mat-cell *matCellDef="let row"> {{row.gestiono}} </td>
                </ng-container>

                <!-- cierre Column -->
                <ng-container matColumnDef="cierre">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cierre </th>
                    <td mat-cell *matCellDef="let row"> {{row.cierre | fechapipe}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezadoMovimientos"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezadoMovimientos;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
</div>